import {useEffect, useCallback} from 'react';
import * as Styled from './CircleProgressBarStyles';

export interface CircleProgressBarStandardProps {
	progress?: number;
}

const CircleProgressBar = ({progress}:CircleProgressBarStandardProps) => {
  const renderProgress = useCallback((progress) => {
    progress = progress/1000*100;
    if(progress<25){
			let angle = -90 + (progress/100)*360;
			document.querySelector<HTMLElement>('.Animate025B')!.style.transform = `rotate(${angle}deg)`;
    }
    else if(progress>=25 && progress<50){
			let angle = -90 + ((progress-25)/100)*360;
			document.querySelector<HTMLElement>('.Animate025B')!.style.transform = 'rotate(0deg)';
			document.querySelector<HTMLElement>('.Animate2550B')!.style.transform = `rotate(${angle}deg)`;
    }
    else if(progress>=50 && progress<75){
			let angle = -90 + ((progress-50)/100)*360;
			document.querySelector<HTMLElement>('.Animate2550B')!.style.transform = 'rotate(0deg)';
			document.querySelector<HTMLElement>('.Animate025B')!.style.transform = 'rotate(0deg)';
			document.querySelector<HTMLElement>('.Animate5075B')!.style.transform = `rotate(${angle}deg)`;
    }
    else if(progress>=75 && progress<=100){
			let angle = -90 + ((progress-75)/100)*360;
			document.querySelector<HTMLElement>('.Animate5075B')!.style.transform = 'rotate(0deg)';
			document.querySelector<HTMLElement>('.Animate2550B')!.style.transform = 'rotate(0deg)';
			document.querySelector<HTMLElement>('.Animate025B')!.style.transform = 'rotate(0deg)';
			document.querySelector<HTMLElement>('.Animate75100B')!.style.transform = `rotate(${angle}deg)`;
    }
  }, []);

  useEffect(() => {
    renderProgress(progress);
  }, [renderProgress, progress]);

  return (
    <Styled.Container className="Loader">
      <Styled.Container className="LoaderBg">
				<Styled.StyledH3>{progress}</Styled.StyledH3>
				<Styled.StyledParagraph>{progress && progress > 1 ? 'Searches' : 'Search' }</Styled.StyledParagraph>
      </Styled.Container>
      <Styled.Container className="SpinerHolderOne Animate025A">
				<Styled.Container className="SpinerHolderTwo Animate025B">
					<Styled.Container className="LoaderSpiner"></Styled.Container>
				</Styled.Container>
      </Styled.Container>
      <Styled.Container className="SpinerHolderOne Animate2550A">
				<Styled.Container className="SpinerHolderTwo Animate2550B">
					<Styled.Container className="LoaderSpiner"></Styled.Container>
				</Styled.Container>
      </Styled.Container>
      <Styled.Container className="SpinerHolderOne Animate5075A">
				<Styled.Container className="SpinerHolderTwo Animate5075B">
					<Styled.Container className="LoaderSpiner"></Styled.Container>
				</Styled.Container>
      </Styled.Container>
      <Styled.Container className="SpinerHolderOne Animate75100A">
				<Styled.Container className="SpinerHolderTwo Animate75100B">
					<Styled.Container className="LoaderSpiner"></Styled.Container>
				</Styled.Container>
      </Styled.Container>
    </Styled.Container>
  );
}

export default CircleProgressBar;